<template>
    <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg p-6">
        <div class="flex flex-wrap items-center justify-between gap-2">
            <h3 class="text-lg font-semibold text-gray-900">Plans &amp; pricing</h3>
        </div>

        <div class="mt-4 overflow-x-auto">
            <table class="min-w-full divide-y divide-gray-200">
                <thead>
                    <tr>
                        <th class="px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-gray-500">Units managed</th>
                        <th class="px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-gray-500">Basic</th>
                        <th class="px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-gray-500">Pro</th>
                        <th class="px-3 py-2 text-left text-xs font-semibold uppercase tracking-wide text-gray-500"></th>
                    </tr>
                </thead>
                <tbody class="divide-y divide-gray-100">
                    <tr
                        v-for="tier in proTiers"
                        :key="tier.slug"
                        :class="{ 'bg-gold-100': tier.slug === currentTierSlug }"
                        :data-test="`tier-row-${tier.slug}`"
                    >
                        <td class="px-3 py-2 text-sm text-gray-900">{{ rangeLabel(tier) }}</td>
                        <td class="px-3 py-2 text-sm text-gray-500">Free</td>
                        <td class="px-3 py-2 text-sm font-medium text-gray-900">{{ yearPrice(tier.price) }}</td>
                        <td class="px-3 py-2 text-sm">
                            <span
                                v-if="tier.slug === currentTierSlug"
                                class="inline-flex items-center rounded-full bg-rent-risk-blue-400 px-2 py-0.5 text-xs font-semibold text-white"
                            >
                                Your tier
                            </span>
                            <span
                                v-else-if="tier.slug === nextTierSlug"
                                class="inline-flex items-center rounded-full bg-gray-100 px-2 py-0.5 text-xs font-semibold text-gray-700"
                            >
                                Next tier
                            </span>
                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PlansPricingCard',
    props: {
        proTiers: {
            type: Array,
            default: () => [],
        },
        proPlan: {
            type: Object,
            default: null,
        },
    },
    computed: {
        currentTierSlug() {
            return this.proPlan?.current_tier?.slug ?? null;
        },
        nextTierSlug() {
            return this.proPlan?.next_tier?.slug ?? null;
        },
    },
    methods: {
        yearPrice(price) {
            return `$${Number(price).toLocaleString('en-US', { minimumFractionDigits: 0, maximumFractionDigits: 2 })}/year`;
        },
        rangeLabel(tier) {
            if (tier.max) {
                return `${tier.min || 1}–${tier.max}`;
            }

            return `${tier.min || 1}+ units`;
        },
    },
};
</script>
